import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {GoogleChartInterface } from 'ng2-google-charts/ng2-google-charts';
import { AlarmsqueryService } from '../service/alarmsquery.service';
import { MarkersService } from '../service/markers.service';
import { MarkerInterface } from '../models/marker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';

declare var mxGraph: any;
declare var mxHierarchicalLayout: any;

@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.css']
})
export class ResumeComponent implements OnInit {


  public MonthdateControl = new FormControl();
  public MonthdateControl2 = new FormControl();

  private subMarkers: any;
  markers: MarkerInterface[];
  public sites: any[] = [];
  
  public sixMonthsAgo = new Date();
  public today = new Date();

  public tree;
  public TopSelector = new FormControl();
  public TopLvlSelected = '';
  public topLevel;
  public MidSelector = new FormControl();
  public MidLvlSelected = '';
  public midLevel;
  public LastSelector = new FormControl();
  public LastLvlSelected = '';
  public lastLevel;

  constructor(private AlarmsService: AlarmsqueryService, private snackBar: MatSnackBar, private markersService: MarkersService,) { }

  public TreeMapChart 
  public data


  public cssClassNames = {
    'headerRow': 'GchartHeader',
    'tableRow': 'GchartRow',
    'oddTableRow': 'GchartRowOdd',};

  public TableMap: GoogleChartInterface ={
    chartType: 'Table',
    dataTable: [
      ['Mike', ''],
      ['Jim',   ''],
      ['Alice', ''],
      ['Bob',   '']
   ],
   options: {
     cssClassNames: this.cssClassNames
    }
  }

  ngOnInit() {
    // google.charts.load('current', {packages:['wordtree']});
    // google.charts.setOnLoadCallback(this.drawChart);
    document.getElementById('ab').className = 'nav-options mat-button selected';
    document.getElementById('ad').className = 'nav-options mat-button';

    this.sixMonthsAgo.setMonth(this.today.getMonth() - 12);
    let dummy = this.today;
    dummy.setDate(1);
    
    this.MonthdateControl.setValue(dummy);
    this.MonthdateControl2.setValue(new Date());
    this.MonthdateControl2.updateValueAndValidity();

    let date1 = new Date(this.MonthdateControl.value);
    let month = (date1.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let start = [date1.getFullYear().toString(), month.toString(), '01'].join('-');
    //fecha fin arreglo
    let date2 = this.MonthdateControl2.value;
    let lastDayOfMonth = new Date(date2.getFullYear(), date2.getMonth()+1, 0);
    let end = [lastDayOfMonth.getFullYear().toString(), (lastDayOfMonth.getMonth()+1).toString(), lastDayOfMonth.getDate().toString()].join('-');
    

    this.AlarmsService.getAlarmsByTime(start, end).subscribe(result =>{
      this.data = result;
      let data = [];
      let preproc = [];
      let devices = [];
      //copio los resultados a un objeto
      for(let alarm in result){
        preproc.push({'desc': result[alarm]['desc'], 'device': result[alarm]['device'], 'location': result[alarm]['office'], 'value': result[alarm]['value'], 'date': result[alarm]['timestamp']})
      }

      //forEach para rellenar las alarmas con sus respectivos valores 
      preproc.forEach(function (a) {
        if(!this[a.desc]){
          this[a.desc] = { desc: a.desc, devID: [], count: 0}
          data.push(this[a.desc])
        }
        if(this[a.desc]){
          this[a.desc].count += 1;
          let newD = true
          for(let name in this[a.desc].devID){
            if(this[a.desc].devID[name].name == a.device)
            {
              this[a.desc].devID[name].count += 1;
              newD = false;
            }
          }
          if(newD){
            this[a.desc].devID.push({name: a.device, count: 1});
            devices.push(a.device);
          }
          
        }

      }, Object.create(null));

      //con esto obtengo los nombres de los dispositivos que emitieron alertas sin repetirlos
      devices = devices.filter(function(item, pos) {
        return devices.indexOf(item) == pos;
      })

      //con esto creo la tabla y asigno respectivamente los valores necesarios
      let table = [['Descripcion']];
      for(let name in devices){table[0].push(devices[name])}
      let rowBuffer;
      for(let alarm in data){
        rowBuffer = [ data[alarm].desc ]
        for(let deviceName in data[alarm].devID){
          let Sname = data[alarm].devID[deviceName].name;
          for(let headerIndex in devices){
            if(rowBuffer.length <= devices.length){rowBuffer.push(0);}
            if(Sname == devices[headerIndex]){
              rowBuffer[parseInt(headerIndex)+1] = data[alarm].devID[deviceName].count;
            }
          }
        }
        table.push(rowBuffer);
      }
      console.log(table);
      this.TableMap.dataTable = table;

      let cComponent = this.TableMap.component;
      let wrapper = cComponent.wrapper;

      cComponent.draw();




    })

    this.subMarkers = this.markersService.getMarkers().subscribe(marker =>{
      this.markers = marker;
      let sitespreproc = [];
      for (let index = 0; index < this.markers.length; index++){
        this.sites.push({'bd_id': this.markers[index].zone + '-' + this.markers[index].city + '-' + this.markers[index].office, 'index': index})
        sitespreproc.push({'zone': this.markers[index].zone, 'city': this.markers[index].city, 'site': this.markers[index].office, 'bd_id': this.markers[index].zone + '-' + this.markers[index].city + '-' + this.markers[index].office})
      }
      this.createTree();
      this.topLevel = Object.keys(this.tree);
      this.midLevel = [];
      this.lastLevel = [];
      //con esto relleno el selector del centro con las ciudades
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          this.midLevel.push(dummy[inds]);
        }
      }
      //con esto relleno el selector final con los sitios
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
          for(let last in dummy2)
          {
            this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})

          }
        }
      }
    })

  }

  openDatePicker(dp) {
    dp.open();
  }

  closeDatePicker1(eventData: any, dp?:any) {
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let fulldate = [year, month, 1].join('-');
    this.MonthdateControl.setValue(new Date(fulldate));
    this.MonthdateControl.updateValueAndValidity();
    dp.close();
  }

  closeDatePicker2(eventData: any, dp?:any) {
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);
    let fulldate = [year, month, 1].join('-');
    this.MonthdateControl2.setValue( lastDayOfMonth );
    this.MonthdateControl2.updateValueAndValidity();
    dp.close();
  }

  searchBD(){
    if(this.MonthdateControl.value > this.MonthdateControl2.value){
      this.snackBar.open('Fecha Inicio no puede ser superior a Fin.', '', {duration: 3000});
    }
    else
    {    
      let date1 = new Date(this.MonthdateControl.value);
      let month = (date1.getMonth() + 1).toString();
      month = month.length > 1 ? month : '0' + month;
      let start = [date1.getFullYear().toString(), month.toString(), '01'].join('-');
      //fecha fin arreglo
      let date2 = this.MonthdateControl2.value;
      let lastDayOfMonth = new Date(date2.getFullYear(), date2.getMonth()+1, 0);
      let Lmonth = (lastDayOfMonth.getMonth()+1).toString();
      Lmonth = Lmonth.length > 1 ? Lmonth : '0'+Lmonth;
      let end = [lastDayOfMonth.getFullYear().toString(), Lmonth, lastDayOfMonth.getDate().toString()].join('-');

      
      this.AlarmsService.getAlarmsByTime(start, end).subscribe(result =>{
        this.data = result;
        this.MidSelector.setValue('');
        this.LastSelector.setValue('');
        let data = [];
        let preproc = [];
        let devices = [];
  
        //copio los resultados a un objeto
        for(let alarm in result){
          preproc.push({'desc': result[alarm]['desc'], 'device': result[alarm]['device'], 'location': result[alarm]['office'], 'value': result[alarm]['value'], 'date': result[alarm]['timestamp']})
        }
  
        //forEach para rellenar las alarmas con sus respectivos valores 
        preproc.forEach(function (a) {
          if(!this[a.desc]){
            this[a.desc] = { desc: a.desc, devID: [], count: 0}
            data.push(this[a.desc])
          }
          if(this[a.desc]){
            this[a.desc].count += 1;
            let newD = true
            for(let name in this[a.desc].devID){
              if(this[a.desc].devID[name].name == a.device)
              {
                this[a.desc].devID[name].count += 1;
                newD = false;
              }
            }
            if(newD){
              this[a.desc].devID.push({name: a.device, count: 1});
              devices.push(a.device);
            }
            
          }
  
        }, Object.create(null));
  
        //con esto obtengo los nombres de los dispositivos que emitieron alertas sin repetirlos
        devices = devices.filter(function(item, pos) {
          return devices.indexOf(item) == pos;
        })
  
        //con esto creo la tabla y asigno respectivamente los valores necesarios
        let table = [['Descripcion']];
        for(let name in devices){table[0].push(devices[name])}
        let rowBuffer;
        for(let alarm in data){
          rowBuffer = [ data[alarm].desc ]
          for(let deviceName in data[alarm].devID){
            let Sname = data[alarm].devID[deviceName].name;
            for(let headerIndex in devices){
              if(rowBuffer.length <= devices.length){rowBuffer.push(0);}
              if(Sname == devices[headerIndex]){
                rowBuffer[parseInt(headerIndex)+1] = data[alarm].devID[deviceName].count;
              }
            }
          }
          table.push(rowBuffer);
        }  
        console.log(table);
        this.TableMap.dataTable = table;
  
        let cComponent = this.TableMap.component;
        let wrapper = cComponent.wrapper;
  
        cComponent.draw(); 
  
      })
    }


  }

  //crea el arbol de sitios
  createTree(){
    //Para obtener divisiones del proyecto *arbol
    this.tree = {};
    for (let parts of this.sites)
    {
      var toplvl = parts.bd_id.split('-')[0];
      var medlvl = parts.bd_id.split('-')[1];
      var lowlvl = parts.bd_id.split('-')[2];
      this.addProps(this.tree, toplvl + "."+medlvl+"."+lowlvl, parts.bd_id);

    }

    var keys = Object.keys(this.tree);
  }

  //funcion para crear el arbol desde BD
  addProps(obj, arr, val) {

    if (typeof arr == 'string')
        arr = arr.split(".");

    obj[arr[0]] = obj[arr[0]] || {};

    var tmpObj = obj[arr[0]];

    if (arr.length > 1) {
        arr.shift();
        this.addProps(tmpObj, arr, val);
    }
    else
        obj[arr[0]] = val;

    return obj;

  }

  //para filtrar selector medio
  filterMidSelectors(){
    this.delay(50).then(any =>{
      this.lastLevel = [];
      if(this.MidSelector.value == ''){
        
        //con esto relleno el selector final con los sitios
        for (let tops in this.topLevel){
          let dummy = Object.keys(this.tree[this.topLevel[tops]])
          for(let inds in dummy)
          {
            let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
            for(let last in dummy2)
            {
              this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
            }
          }
        }
      }
      else
      {
        //con esto relleno el selector final con los sitios
        for (let tops in this.topLevel){
          let dummy = Object.keys(this.tree[this.topLevel[tops]])
          for(let inds in dummy)
          {
            let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
            for(let last in dummy2)
            {
              if(this.MidSelector.value.includes(dummy[inds]))
                {
                  this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
                }
            }
          }
        }
      }
      this.LastSelector.setValue(this.lastLevel);
    })
  }

  //para filtrar ultimo nivel
  filterLastSelector(){
    this.delay(50).then(any =>{
      if(this.LastSelector.value != '')
      {
        let lastlvl = [];
        let top = [];
        let mid = [];
        for(let i in this.LastSelector.value){
          let dummy = this.LastSelector.value[i].id;
          dummy = dummy.split('/');
          lastlvl.push(this.LastSelector.value[i].name);
          mid.push(dummy[1]);
          top.push(dummy[0]);
        }
        this.filtrar(top, mid, lastlvl);
      }
      else
      {
        console.log('debug')
        // if(this.MidSelector.value != null)
        // {
        //   this.Nivel = this.MidSelector.value
        // }
        // else
        // {
        //   if(this.TopSelector.value != null)
        //   {
        //     this.Nivel = this.TopSelector.value;
        //   }
        //   else
        //   {
        //     this.Nivel = 'Nivel País'
        //   }
        // }        
      }
      
    });
  }

  filtrar(crit1, crit2:any = '0', crit3:any = '0'){
    if(crit3.length >= 1)
    {
      {
        let dummy = []
        for(let ind in crit3)
        {
          dummy = dummy.concat(this.data.filter(function(criteria){
            return criteria.office == crit3[ind]
          }))
        }
        this.actualizarTabla(dummy);
        
        //this.actualizarTabla(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
      }      
    }      
  }

  actualizarTabla(dummy){
     //copio los resultados a un objeto
     let result = dummy;
     let data = [];
     let preproc = [];
     let devices = [];

     //copio los resultados a un objeto
     for(let alarm in result){
       preproc.push({'desc': result[alarm]['desc'], 'device': result[alarm]['device'], 'location': result[alarm]['office'], 'value': result[alarm]['value'], 'date': result[alarm]['timestamp']})
     }

     //forEach para rellenar las alarmas con sus respectivos valores 
     preproc.forEach(function (a) {
       if(!this[a.desc]){
         this[a.desc] = { desc: a.desc, devID: [], count: 0}
         data.push(this[a.desc])
       }
       if(this[a.desc]){
         this[a.desc].count += 1;
         let newD = true
         for(let name in this[a.desc].devID){
           if(this[a.desc].devID[name].name == a.device)
           {
             this[a.desc].devID[name].count += 1;
             newD = false;
           }
         }
         if(newD){
           this[a.desc].devID.push({name: a.device, count: 1});
           devices.push(a.device);
         }
         
       }

     }, Object.create(null));

     //con esto obtengo los nombres de los dispositivos que emitieron alertas sin repetirlos
     devices = devices.filter(function(item, pos) {
       return devices.indexOf(item) == pos;
     })

     //con esto creo la tabla y asigno respectivamente los valores necesarios
     let table = [['Descripcion']];
     for(let name in devices){table[0].push(devices[name])}
     let rowBuffer;
     for(let alarm in data){
       rowBuffer = [ data[alarm].desc ]
       for(let deviceName in data[alarm].devID){
         let Sname = data[alarm].devID[deviceName].name;
         for(let headerIndex in devices){
           if(rowBuffer.length <= devices.length){rowBuffer.push(0);}
           if(Sname == devices[headerIndex]){
             rowBuffer[parseInt(headerIndex)+1] = data[alarm].devID[deviceName].count;
           }
         }
       }
       table.push(rowBuffer);
     }

     this.TableMap.dataTable = table;

     let cComponent = this.TableMap.component;
     let wrapper = cComponent.wrapper;

     cComponent.draw(); 
  }

  //delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>null);
  }

}
